var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSimpleIllustrationQrCode = function SvgSimpleIllustrationQrCode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34.882,
    height: 34.882,
    x: 6.559,
    y: 6.559,
    fill: "#FCDCFF",
    stroke: "#002140",
    rx: 4.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#003C73",
    d: "M11.294 22.185h10.89v-10.89h-10.89v10.89Zm3.63-7.26h3.63v3.63h-3.63v-3.63Zm10.891-3.63v10.89h10.891v-10.89h-10.89Zm7.26 7.26h-3.63v-3.63h3.63v3.63Zm-21.78 18.15h10.89v-10.89h-10.89v10.89Zm3.63-7.26h3.63v3.63h-3.63v-3.63Zm19.966-3.63h1.815v7.26h-5.445V31.26h-1.816v5.446h-3.63v-10.89h5.446v1.814h3.63v-1.815Zm0 9.076h1.815v1.815h-1.815V34.89Zm-3.63 0h1.815v1.815H31.26V34.89Z"
  })));
};
export default SvgSimpleIllustrationQrCode;